const ErrorDisplayed = () => {
    return (
        <main>
            <h1>Oops la ruta que buscas no existe</h1>
        </main>
    )
}

export default ErrorDisplayed